/* Generic file upload window, with options for upload url and file type filter.
   Not to be confused with Client Upload Window */

Librarian.FileUploadWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["uploadClicked", "promptRename", "sendUploadRequest", "onAddFileClick", "onRemoveFileClick"],

    options: {
        id: "fileUploadWindow",
        width: 315,
        height: 120,
        uploadUrl: null,
        // Accept parameter for file input, (e.g. "audio/*")
        acceptType: null,
        titleText: "upload_file",
        buttonText: "upload",
        successText: "upload_success",
        fileNameOverride: null,
        xmlData: null,
        allowExtensions: null,
        allowMultiple: false,
        maxFileCount: 5
    },

    fileName: null,
    onBeforeUpload: null,
    onSuccess: null,
    progressID: null,

    fileCount: 1,
    fileHeight: 0,

    initialize: function(options) {
        this.setOptions(options);

        this.onBeforeUpload = options.onBeforeUpload;
        this.onSuccess = options.onSuccess;

        if (!this.options.uploadUrl)
            throw "No upload url specified";

        this.options.title = Librarian.Lang.getString(this.options.titleText);

        if (this.options.allowMultiple) {
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/filemultiupload.html";
            this.options.width += 30;
        }
        else
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/fileupload.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("selectFile");
        if (itemEl && (typeof this.options.acceptType == "string"))
            itemEl.setAttribute("accept", this.options.acceptType);

        itemEl = this.getElement("submitButton");
        if (itemEl) {
            itemEl.addOnClick(this.uploadClicked);
            itemEl.set("text", Librarian.Lang.getString(this.options.buttonText));
        }

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("addFileButton");
        if (itemEl)
            itemEl.addOnClick(this.onAddFileClick);

        itemEl = this.getElement("removeFileButton");
        if (itemEl)
            itemEl.addOnClick(this.onRemoveFileClick);

        itemEl = this.getElement("selectFile");
        if (itemEl)
            this.fileHeight = itemEl.getHeight();
    },

    uploadClicked: function() {
        var formEl = this.getElement("uploadForm");
        if (!formEl)
            return;

        var fileEls = formEl.getElements("input[type=file]"),
            fileCount = 0;
        for (var i = fileEls.length; i--;) {
            var fileEl = formEl[i];
            if (!fileEl)
                continue;

            var path = Librarian.Utils.getElementValue(fileEl) || '';
            if (path.length == 0)
                continue;

            this.fileName = Librarian.Utils.getFileNameFromPath(path);
            if (this.options.allowExtensions && (typeof this.options.allowExtensions.length == "number")) {
                var extensions = Array.from(this.options.allowExtensions),
                    extension = Librarian.Utils.getExtension(this.fileName);

                // If this extension isn't in the allowed list, don't continue
                if (!extensions.contains(extension)) {
                    Librarian.Utils.error(Librarian.Lang.getArgString("upload_type_disallowed", [extension, extensions]));
                    return;
                }
            }

            fileCount++;
        }

        if (fileCount == 0) {
            // If no file was chosen, show an error to the user
            Librarian.Utils.error(Librarian.Lang.getString("upload_select"));
            return;
        }

        // Disable the submit button so it cannot be clicked multiple times
        Librarian.Utils.setButtonDisabled(this.getElement("submitButton"), true);

        if (typeof this.onBeforeUpload == "function")
            this.onBeforeUpload(this.sendUploadRequest);
        else
            this.sendUploadRequest();
    },

    sendUploadRequest: function() {
        var buttonEl = this.getElement("submitButton"),
            formEl = this.getElement("uploadForm");

        if (!formEl)
            return;

        formEl.action = this.options.uploadUrl + "&outformat=text";

        if (this.options.xmlData) {
            new Element("input[hidden]", {
                "value": this.options.xmlData,
                "name": "xdata"
            }).injectInside(formEl);
        }

        if (!this.options.allowMultiple && this.options.fileNameOverride) {
            var newFileName = "";

            if (typeOf(this.options.fileNameOverride) === "function") {
                newFileName = this.options.fileNameOverride(this.fileName);
            } else {
                newFileName = this.options.fileNameOverride;
            }

            new Element("input[hidden]", {
                "value": newFileName,
                "name": "file_name_0"
            }).injectInside(formEl);
        }

        this.request = new iFrameFormRequest(formEl.id, {
            onComplete: function(responseDoc) {
                Librarian.Utils.hideProgressImage(this.progressID);

                // Only show the "Success" message if this wasn't a failure
                if ((typeof this.onSuccess == "function") && (this.onSuccess(responseDoc) !== false))
                    Librarian.Utils.notification(Librarian.Lang.getString(this.options.successText));

                this.close();
            }.bind(this),
            onFailure: function() {
                Librarian.Utils.error(Librarian.Lang.getString("upload_failed"));
                Librarian.Utils.hideProgressImage(this.progressID);

                // Clear the request
                this.request = null;

                // Re-enable the submit button
                Librarian.Utils.setButtonDisabled(buttonEl, false);
            }.bind(this)
        });
        this.request.send();
        this.progressID = Librarian.Utils.showProgressImage(this.contentWrapperEl);
    },

    onAddFileClick: function () {
        if ((this.maxFileCount > 0) && ((this.fileCount + 1) > this.options.maxFileCount))
            return;

        var addEl = this.getElement("addFileButton");
        if (!addEl || addEl.disabled)
            return;

        var fileEl = this.getElement("selectFile");
        if (!fileEl)
            return;

        var parentEl = this.getElement("fileContainer");
        if (!parentEl)
            return;

        this.options.height += this.fileHeight;
        this.resize({
            height: this.options.height,
            width: this.options.width
        });

        var cloneEl = fileEl.clone(),
            name = cloneEl.name;

        name = name.substring(0, name.indexOf('_') + 1);

        cloneEl.name = name + this.fileCount;
        cloneEl.id = '';
        Librarian.Utils.setElementValue(cloneEl, '');
        cloneEl.injectInside(parentEl);

        this.fileCount++;

        if (this.fileCount >= this.options.maxFileCount)
            Librarian.Utils.setButtonDisabled(addEl, true);
        if (this.fileCount > 1)
            Librarian.Utils.setButtonDisabled(this.getElement("removeFileButton"), false);
    },

    onRemoveFileClick: function() {
        var removeEl = this.getElement("removeFileButton");
        if ((this.fileCount <= 1) || !removeEl || removeEl.disabled)
            return;

        var parentEl = this.getElement("fileContainer");
        if (!parentEl)
            return;

        var fileEl = parentEl.getElement("[name=file_" + (this.fileCount - 1) + ']');
        if (!fileEl)
            return;

        fileEl.destroy();
        this.fileCount--;
        Librarian.Utils.setButtonDisabled(this.getElement("addFileButton"), false);

        this.options.height -= this.fileHeight;
        this.resize({
            height: this.options.height,
            width: this.options.width
        });

        if (this.fileCount <= 1)
            Librarian.Utils.setButtonDisabled(removeEl, true);
    }
});